module.exports = __webpack_public_path__ + "media/images/database-solid-196e1baf179d3e7c137856457a11c083.svg";